import { ApolloProvider } from '@apollo/client';
import { ApmRoutes } from '@elastic/apm-rum-react';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation, useNavigate } from 'react-router-dom';
import { NavigationService, useGTM, useVWO } from '../../common';
import { apolloClientAdditional } from '../../common/api/apollo/additional';
import { apolloClient } from '../../common/api/apollo/supplementary';
import { MainRouting } from './main.routes';

const ADDITIONAL_PATH = 'dodatno-zdravstveno-osiguranje';

const MainRouter = () => {

  const RoutesWrapper = ({ children }: {
    children: React.ReactNode;
  }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const isAdditional = pathname.includes(ADDITIONAL_PATH);
    const client = isAdditional ? apolloClientAdditional : apolloClient;

    useGTM();
    useVWO();

    useEffect(() => {
      NavigationService.setNavigateFunction(navigate);
    }, [navigate]);

    return (
      <ApolloProvider client={client}>
        <ApmRoutes>
          {children}
        </ApmRoutes>
      </ApolloProvider>
    );
  };

  return (
    <Router>
      <RoutesWrapper>
        {NavigationService.generateRoutes(MainRouting())}
      </RoutesWrapper>
    </Router>
  )
}

export default MainRouter;
